export default __webpack_public_path__ + "static/media/people-banner-img.b0f7624d.png";